import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import { t } from '../../translations/i18n';
import MikeButton from '../../shared-components/mike-button';

type ConfirmMeshMultipleDeleteDialogProps = {
  open: boolean;
  onClose: (confirmed: boolean) => void;
};

/**
 * Shows a confimation dialog for deleting multiple meshes and notifies a parent component of deletion through a callback.
 *
 * @param props
 */
export const MmgConfirmMeshMultipleDeleteDialog = (props: ConfirmMeshMultipleDeleteDialogProps) => {
  const { open, onClose } = props;

  const handleClose = () => {
    onClose(false);
  };

  const handleOk = () => {
    closeDialog(true);
  };

  const handleCancel = () => {
    closeDialog(false);
  };

  const closeDialog = (confirmed: boolean) => {
    onClose(confirmed);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      id="confirm-delete-mesh"
      aria-labelledby="delete-mesh-dialog-title"
      aria-describedby="delete-mesh-dialog-description"
    >
      <DialogTitle id="delete-mesh-dialog-title">
        {t('MESH_CONFIRM_DELETE_TITLE', 2)}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-mesh-dialog-description">{t('MESH_CONFIRM_DELETE_TEXT', 2)}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <MikeButton onClick={handleCancel} variant="outlined" color="secondary">
          {t('CANCEL')}
        </MikeButton>
        <MikeButton onClick={handleOk} variant="contained" color="secondary" autoFocus>
          {t('DELETE')}
        </MikeButton>
      </DialogActions>
    </Dialog>
  );
};
